export default "__VITE_ASSET__DHy2FIrV__"